// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"a9a3ad98","167":"24839520","620":"794be8ed","676":"718d6f92","787":"72276660","820":"796326ad"}[chunkId] + ".chunk.js";
};